class CodectibleLatestVideo extends HTMLElement {
    constructor() {
        super();

        this.videoSourceParent = this.dataset.parent;

        if (!this.videoSourceParent || this.videoSourceParent == "") {
            console.warn('Latest Video Parent missing');
            return;
        }

        
        this.selectors = {
            videoContainer: '.js-codectible-latest-video-container',
            videoSourceParent: `#${this.videoSourceParent}`
        }

        

        this.init();
    }

    init() {
        this.setupEventListeners();
    }

    setupEventListeners() {
        document.addEventListener(`${this.videoSourceParent}.loaded`, this.handleParentLoaded.bind(this))
    }

    handleParentLoaded() {
        console.log('iis loaded: ', this.selectors.videoSourceParent);

        let latestVideo = document.querySelector(this.selectors.videoSourceParent).popLatestVideo();

        let videoProps = "autoplay playsinline loop muted controls"

        let $videoContainer = $(this.querySelector(this.selectors.videoContainer));
        $videoContainer.append(`<video class="mobile-hide codectible-latest-video" src="${latestVideo.video}" ${videoProps} />`);
        $videoContainer.append(`<video class="desktop-hide codectible-latest-video" src="${latestVideo.mobile_video}" ${videoProps} />`);
        $videoContainer.addClass('video-loaded')
    }
}

customElements.define('codectible-latest-video', CodectibleLatestVideo);

